import React from 'react';

export const RenderFaston6_3 = ({ color, x, y, scale = 0.05, side = 'A', rotate = 0 }) => {
  return (
    <g transform={`translate(${x},${y}) scale(${scale}) rotate(${rotate})`}>
        <g style={{ transformOrigin: '0px 0px' }}>
          
          {/* PARTI METALLICHE GRIGIE */}
          <path d="M -157.6 97.7 C -164.1 105.994 -168.907 105.606 -184.3 116.1 L -350 116.1 L -350 -116.1 L -184.3 -116.1 C -176.505 -113.365 -170.903 -105.167 -157.6 -97.7 L 0.8 -97.7 L 31.1 -97.843 L 31.1 -60 L 101.1 -149.2 L 350 -149.9 L 350 149.9 L 101.1 149.2 L 31.1 60.188 L 30.536 98.126 Z M 255 65.81 L 295 65.81 L 295 -66.2 L 255 -66.2 Z M 160 65.825 L 200 65.825 L 200 -66.185 L 160 -66.185 Z" 
                fill="#BFBFBF" fillRule="evenodd"/>
          
          {/* ISOLAMENTO COLORATO */}
          <path d="M -184.3 116.1 L -184.3 -116.1 L -350 -116.1 L -350 116.1 L -184.3 116.1" 
                fill={color} fillRule="evenodd"/>
          
          <path d="M 29.549 97.7 L 29.549 -97.7 L -157.6 -97.7 L -157.6 97.7 L 29.549 97.7" 
                fill={color} fillRule="evenodd"/>
          
          <path d="M -157.6 -97.7 L -157.6 97.7 C -169.271 108.557 -175.975 113.69 -184.3 116.1 L -184.3 -116.1 C -174.829 -107.742 -165.482 -101.46 -157.6 -97.7" 
                fill={color} fillRule="evenodd"/>
          
          <path d="M 31.1 105.4 L 31.1 60 L 31.1 -59.93" 
                fill={color} fillRule="evenodd"/>
          
          {/* CONTORNI ESTERNI - 8px */}
          <path d="M -350 -116.1 L -350 116.1" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 349.999 -149.9 L 349.999 -91.2" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 350 -91.2 L 350 91.2" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 350 91.2 L 350 149.9" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M -184.3 -116.1 L -350 -116.1" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M -184.3 116.1 L -350 116.1" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 101.522 -149.9 L 350 -149.9" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 101.061 149.9 L 350.001 149.9" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M -157.6 -97.7 C -166.5 -103.833 -175.4 -109.967 -184.3 -116.1" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M -157.6 97.7 C -166.5 103.833 -175.4 109.967 -184.3 116.1" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 30.267 97.7 L 30.267 -97.7" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 101.1 -149.2 L 31.1 -60" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 101.1 149.2 L 31.1 60" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 30.3 -97.7 L -157.6 -97.7" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 29.988 97.714 L -157.6 97.7" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 101.1 -66.2 L 101.1 -149.2" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 101.1 149.2 L 101.1 66.2" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 101.1 -66.2 L 350 -66.2" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          <path d="M 101.1 66.2 L 350 66.2" stroke="#212529" strokeWidth="8" fill="none" strokeLinecap="round"/>
          
          {/* CONTORNI INTERNI - 4px */}
          <path d="M -184.3 116.1 L -184.3 -116.1" stroke="#212529" strokeWidth="4" fill="none" strokeLinecap="round"/>
          <path d="M -157.6 -97.7 L -157.6 97.7" stroke="#212529" strokeWidth="4" fill="none" strokeLinecap="round"/>
          <path d="M 112.7 -149.2 L 112.7 -149.9" stroke="#212529" strokeWidth="4" fill="none" strokeLinecap="round"/>
          <path d="M 112.7 149.2 L 112.7 149.9" stroke="#212529" strokeWidth="4" fill="none" strokeLinecap="round"/>
          <path d="M 101.1 91.2 L 31.1 36.6" stroke="#212529" strokeWidth="4" fill="none" strokeLinecap="round"/>
          <path d="M 101.1 -91.2 L 31.1 -36" stroke="#212529" strokeWidth="4" fill="none" strokeLinecap="round"/>
          
          {/* LINEE VERTICALI INTERNE */}
          <line x1="160" y1="-66.4" x2="160" y2="65.9" stroke="#000000" strokeWidth="4"/>
          <line x1="255.429" y1="-66.4" x2="255.429" y2="65.9" stroke="#000000" strokeWidth="4"/>
          <line x1="200.199" y1="-66.4" x2="200.199" y2="65.9" stroke="#000000" strokeWidth="4"/>
          <line x1="294.929" y1="-66.4" x2="294.929" y2="65.9" stroke="#000000" strokeWidth="4"/>
          
        </g>
      </g>
  );
};

